const Images = {
  logo: require('../assets/images/follo-logo.png'),
  logoWhite: require('../assets/images/follo-logo-white.png'),
  background: require('../assets/images/background-follo.jpg'),
  emptyCampaign: require('../assets/images/empty-campaign.svg'),
};

export default Images;



// WEBPACK FOOTER //
// ./src/advertisers/themes/Images.js